import { initTheme, toggleTheme } from "./theme";
import { initMenu, toggleMenu } from "./menu";
import { toggleBib, copyBib, filterPubs, initAuthorLinks, initSearchFromUrl } from "./bibliography";

/* Initialize theme immediately (before DOMContentLoaded) */
initTheme();

/* Expose globals for onclick handlers in HTML templates */
declare global {
  interface Window {
    toggleTheme: () => void;
    toggleMenu: () => void;
    toggleBib: (key: string) => void;
    copyBib: (key: string) => void;
    filterPubs: (input: HTMLInputElement) => void;
  }
}

window.toggleTheme = toggleTheme;
window.toggleMenu = toggleMenu;
window.toggleBib = toggleBib;
window.copyBib = copyBib;
window.filterPubs = filterPubs;

/* Initialize on DOM ready */
initMenu();
document.addEventListener("DOMContentLoaded", () => {
  initSearchFromUrl();
  initAuthorLinks();
});
